<template>
  <div id="page-content">
    <NavBar/>
    <div id="main-component">

      <transition
          name="fade"
          mode="out-in">
        <router-view class="mx-6 my-4"/>
      </transition>

    </div>
    <Footer/>
  </div>
</template>


<script>
  import NavBar from '/src/components/NavBar.vue'
  import Footer from '/src/components/Footer.vue'
  // import axios from "axios";
  // import router from "./router";

  export default {
    name: 'home',
    components: {
      NavBar,
      Footer
    },
    methods: {
      // logout: function () {
      //   axios
      //     .get("http://localhost:3000/api2/logout")
      //     .then(() => router.push("/login"))
      // }
    }
  }
</script>

<style>
    body {
      overflow-y:scroll;
    }
    #page-content {
      min-height: 100vh;
      position: relative;
      display: flex;
      flex-direction: column;
      color: var(--color-text-2)
    }
    #main-component {
      flex: 1 0;
    }


    .fade-enter-active,
    .fade-leave-active {
      transition: opacity .5s ease-in-out;
    }

    .fade-enter,
    .fade-leave-active {
      opacity: 0
    }

    :root {
        --color-background: #eeeeee;
        --color-background-transparent: #eeeeee00;
        --color-cards: #ffffff;
        --color-footer-1: #d5d5d5;
        --color-footer-2: #bebebe;

        --color-buttons: #f9f9f9;
        --color-main: #5abcb9;
        --color-text-0: #282828;
        --color-text-1: #3b3b3b;
        --color-text-2: #5d5d5d;
        --color-text-3: #8b8b8b;
        --color-text-4: #b3b3b3;
        --color-text-5: #eaeaea;

        --color-link: #5ca2b4;
        --color-hover: #b4dce7;
        --color-selected: #9bd2e0;
        --color-selected-hover: #c8f0fa;
        --color-light: #ffffff;
        --color-good: #3da560;
        --color-yellow: #f9a62b;
        --color-bad: #ec4145;

        --gradient-cards: linear-gradient(rgba(255, 255, 255, 0) 60%, rgba(255, 255, 255, 0.7) 85%, var(--color-cards) 100%);
    }
    :root.dark-theme {
        --color-background: #292d31;
      --color-background-transparent: #292d3100;
        --color-cards: #2f3136;
        --color-main: #5abcb9;
        --color-footer-1: #1e2224;
        --color-footer-2: #14191a;

        --color-buttons: #242528;
        --color-text-0: #ffffff;
        --color-text-1: #cecece;
        --color-text-2: #b6b6b6;
        --color-text-3: #909090;
        --color-text-4: #666666;
        --color-text-5: #3e3e40;

        --color-link: #5ca2b4;
        --color-hover: #17191d;
        --color-selected: #4d5a5c;
        --color-selected-hover: #3d3f49;
        --color-light: #e2e2e2;

        --gradient-cards: linear-gradient(rgba(47, 49, 54, 0) 60%, rgba(47, 49, 54, 0.7) 85%, rgb(47, 49, 54) 100%);
    }
</style>